import React from 'react';
import { Route, Redirect } from 'react-router-dom';

/**
 * ProtectedRoute component that redirects to login if the user is not logged in
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isLoggedIn - Whether the user is logged in
 * @param {Function} props.render - Render function for the route
 * @param {string} props.path - Route path
 * @param {boolean} props.exact - Whether the route is exact
 * @returns {React.Component} Protected route component
 */
const ProtectedRoute = ({ isLoggedIn, render, path, exact, ...rest }) => {
  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(props) => 
        isLoggedIn ? (
          render(props)
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              search: `?lp=${props.location.pathname}`,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
